/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BillingWalletType } from './BillingWalletType';
import {
    BillingWalletTypeFromJSON,
    BillingWalletTypeFromJSONTyped,
    BillingWalletTypeToJSON,
    BillingWalletTypeToJSONTyped,
} from './BillingWalletType';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';

/**
 * 
 * @export
 * @interface ListBillingWalletTypesResponse
 */
export interface ListBillingWalletTypesResponse {
    /**
     * 
     * @type {Array<BillingWalletType>}
     * @memberof ListBillingWalletTypesResponse
     */
    data: Array<BillingWalletType>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListBillingWalletTypesResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ListBillingWalletTypesResponse interface.
 */
export function instanceOfListBillingWalletTypesResponse(value: object): value is ListBillingWalletTypesResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListBillingWalletTypesResponseFromJSON(json: any): ListBillingWalletTypesResponse {
    return ListBillingWalletTypesResponseFromJSONTyped(json, false);
}

export function ListBillingWalletTypesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListBillingWalletTypesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(BillingWalletTypeFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function ListBillingWalletTypesResponseToJSON(json: any): ListBillingWalletTypesResponse {
      return ListBillingWalletTypesResponseToJSONTyped(json, false);
  }

  export function ListBillingWalletTypesResponseToJSONTyped(value?: ListBillingWalletTypesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(BillingWalletTypeToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

